// external imports
import React from 'react'
import { grey5 } from 'quark-web/styles'
// local imports
import './timer.css'

export default () => (
    <div
        className="la-ball-scale"
        style={{
            color: grey5
        }}
    >
        <div />
    </div>
)



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js